import { Injectable, NgZone } from '@angular/core';
import { ModalController, AlertController, LoadingController } from '@ionic/angular';
import { User } from 'src/app/classes/user';
import { Punto } from 'src/app/classes/punto';
import { Retiro } from 'src/app/classes/retiro';
import { Direccion } from 'src/app/classes/direccion';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(
    private modalController: ModalController,
    private alertCtrl: AlertController,
    private loadingController: LoadingController,
    public zone: NgZone,
  ) { 
  }



  ///////MODALS//////////
  async edcModal(component, object, pedido?){
      const modal = await this.modalController.create({
        component: component,
        componentProps: {objeto: object, pedido: pedido}
      });
      await modal.present();
      const { data } = await modal.onDidDismiss();
      return data;
  }


  ///ALERTS
  async presentSimpleAlert(header, subheader, message, button) {
    const alert = await this.alertCtrl.create({
      header: header,
      subHeader: subheader,
      message: message,
      buttons: [button]
    });
    await alert.present();
  }
  async presentSimpleAlertAutoDismiss(header, subheader, message) {
    const alert = await this.alertCtrl.create({
      header: header,
      subHeader: subheader,
      message: message,
    });
    await alert.present();
    setTimeout(function name() {
      alert.dismiss();
    }, 1000);
  }
  async presentAlertInput(header,message, type, placeholder, value) {
    const alert = await this.alertCtrl.create({
      header: header,
      subHeader:message,
      inputs: [
        {
          name: 'param',
          type: type,
          placeholder: placeholder,
          value: value
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
            alert.dismiss("");
          }
        }, {
          text: 'Aceptar',
          handler: (data) => {
            console.log('Confirm Ok');
            alert.dismiss(data)
          }
        }
      ]
    });

    await alert.present();
    let data;
    await alert.onDidDismiss().then((res) => {
        data = res
    })
    return data
  }
  async presentAlertEditDireccion(direccion:Direccion) {
    let resolveFunction: (confirm: any) => void;
    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });
    const alert = this.alertCtrl.create({
      header: "Editar información",
      inputs: [
        {
          name: 'calle',
          type: "text",
          placeholder: "Calle...",
          value: direccion.calle
        },
        {
          name: 'nro',
          type: "number",
          placeholder: "Número...",
          value: direccion.nro
        },
        {
          name: 'dpto',
          type: "text",
          placeholder: "Departamento...",
          value: direccion.dpto
        },
        {
          name: 'piso',
          type: "text",
          placeholder: "Piso...",
          value: direccion.piso
        },
        {
          name: 'lote',
          type: "text",
          placeholder: "Lote...",
          value: direccion.lote
        },
        {
          name: 'mza',
          type: "text",
          placeholder: "Manzana...",
          value: direccion.mza
        },
        {
          name: 'barrio',
          type: "text",
          placeholder: "Barrio...",
          value: direccion.barrio
        },
        {
          name: 'localidad',
          type: "text",
          placeholder: "Localidad...",
          value: direccion.localidad
        },
        {
          name: 'pais',
          type: "text",
          placeholder: "Pais...",
          value: direccion.pais
        },
        {
          name: 'nota',
          type: "text",
          placeholder: "Nota...",
          value: direccion.nota
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          role: 'ok',
          text: 'Aceptar',
          handler: (data) => resolveFunction(data)
        }
      ]
    });
    (await alert).present();
    return promise;
  }

  async presentAlertEditProfileInfo(user:User) {
    let resolveFunction: (confirm: any) => void;
    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });
    const alert = this.alertCtrl.create({
      header: "Editar información",
      inputs: [
        {
          name: 'name',
          type: "text",
          placeholder: "Nombre...",
          value: user.datos.name
        },
        {
          name: 'apellido',
          type: "text",
          placeholder: "Apellido...",
          value: user.datos.apellido
        },
        {
          name: 'celular',
          type: "number",
          placeholder: "Celular...",
          value: user.datos.celular
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          role: 'ok',
          text: 'Aceptar',
          handler: (data) => resolveFunction(data)
        }
      ]
    });
    (await alert).present();
    return promise;
  }
  async presentAlertEditInstituteData(institute) {
    let resolveFunction: (confirm: any) => void;
    let promise = new Promise<any>(resolve => {
      resolveFunction = resolve;
    });
    const alert = this.alertCtrl.create({
      header: "Editar información de contacto",
      message: "Verifique cada dato ingresado",
      inputs: [
        {
          name: 'whatsapp',
          type: "number",
          placeholder: "Número de whatsapp...",
          value: institute.whatsapp
        },
        {
          name: 'facebook',
          type: "text",
          placeholder: "Cuenta de Facebook...",
          value: institute.facebook
        },
        {
          name: 'instagram',
          type: "text",
          placeholder: "Cuenta de Instagram...",
          value: institute.instagram
        },        
        {
          name: 'email',
          type: "email",
          placeholder: "Email institucional...",
          value: institute.email
        },
        {
          name: 'web',
          type: "text",
          placeholder: "Link de pagina web...",
          value: institute.web
        },        
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Aceptar',
          handler: (data) => resolveFunction(data)
        }
      ]
    });
    (await alert).present();
    return promise;
  }
  async presentAlertConfirm(header, message) { 
    const alert = await this.alertCtrl.create({
      header: header,
      message: message,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Aceptar',
          role: 'ok',
          handler: () => {
            console.log('Confirm Ok');
          }
        }
      ]
    });
    
    let choice;
    await alert.present();
    await alert.onDidDismiss().then((data) => {
      choice = data
    });
    return choice;
  }
    /////LOADER/////
    async showLoaderControllable(message){
      const loading = await this.loadingController.create({
        spinner: "lines",
        duration: 120500,
        message: message,
        translucent: true,
        cssClass: 'custom-class custom-loading',
        backdropDismiss: false
      });
      return loading;
    }
    async showLoaderSmall(message){
      const loading = await this.loadingController.create({
        spinner: "bubbles",
        duration: 2500,
        message: message,
        translucent: true,
        cssClass: 'custom-class custom-loading',
        backdropDismiss: true
      });
      await loading.present();
    }


    ////AUX
    makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
         result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result.toUpperCase();
    }   
    getDia(dia){
      let stDia={dia:'', num:''};
      var fecha = new Date(parseInt(dia));
      var options:any = { weekday: 'long'};
      stDia.dia=fecha.toLocaleDateString("es-ES", options);
      var options2:any = { day: 'numeric'};
      stDia.num=fecha.toLocaleDateString("es-ES", options2);
      return stDia;
    }
    getMesYAno(timestamp){
      let mes_año={mes:'', ano:''};
      var fecha = new Date(parseInt(timestamp));
      var options:any = { month: 'long'};
      mes_año.mes=fecha.toLocaleDateString("es-ES", options);
      var options2:any = { year: 'numeric'};
      mes_año.ano=fecha.toLocaleDateString("es-ES", options2);
      return mes_año;
    }
    searchByReciclable(evt, array){
      const searchTerm = evt.srcElement.value;
      if (!searchTerm) {
        return array;
      }
      if (searchTerm.length<3) {
        return array;
      }
      array = array.filter((item:Punto) => {
        for (let index = 0; index < item.reciclables.length; index++) {
          const reciclable = item.reciclables[index];
          console.log(reciclable);
          if (reciclable && searchTerm) {
            if (reciclable.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
             return true;
            }  
          }
        }
        
      });
      return array;
    } 
    calcCrow(lat11, lon1, lat22, lon2) 
    {
      var R = 6371; // km
      var dLat = this.toRad(lat22-lat11);
      var dLon = this.toRad(lon2-lon1);
      var lat1 = this.toRad(lat11);
      var lat2 = this.toRad(lat22);

      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      var d = R * c;
      return d*1000;
    }

    // Converts numeric degrees to radians
    toRad(Value) 
    {
        return Value * Math.PI / 180;
    }
    searchByEmail(evt, array){
      const searchTerm = evt.srcElement.value;
      if (!searchTerm) {
        return [];
      }
      if (searchTerm.length<3) {
        return [];
      }
      array = array.filter((item:User) => {
        if (item.datos.email && searchTerm) {
          if (item.datos.email.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
           return true;
          }  
        }
      });
      return array;
    } 
    filterBarriosList(evt, array){
      const searchTerm = evt.srcElement.value;
      if (!searchTerm) {
        return;
      }
      if (searchTerm.length<3) {
        return;
      }
      array = array.filter(item => {
        if (item.nombre && searchTerm) {
          if (item.nombre.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
           return true;
          }
          return false;
        }
      });
      return array;
    } 

    analizarDuplicadosByUid(item, array){
      var isInArray=false;
      var posicionDuplicado=null;
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if(element.uid==item.uid){
            isInArray=true;
            posicionDuplicado=index;
          }
        }
      if(isInArray){
        array.splice(posicionDuplicado, 1);
      }
      array.push(item);
      return array;
    }
    analizarNoDuplicadosById(item, array){
      var isInArray=false;
      var posicionDuplicado=null;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if(element.id==item.id){
          isInArray=true;
          posicionDuplicado=index;
        }
      }
      if(isInArray){
        array.splice(posicionDuplicado, 1);
      }
      array.push(item);
      return array;
    }
    analizarNoDuplicadosByDia(item:Retiro, array:Retiro[]){
      var isInArray=false;
      var posicionDuplicado=null;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if(element.dia == item.dia){
          isInArray=true;
          posicionDuplicado=index;
        }
      }
      if(isInArray){
        array.splice(posicionDuplicado, 1);
      }
      array.push(item);
      return array;
    }
    analizarDuplicadosByUrl(item, array){
      var isInArray=false;
      var posicionDuplicado=null;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if(element.url==item.url){
          isInArray=true;
          posicionDuplicado=index;
        }
      }
      if(isInArray){
        array.splice(posicionDuplicado, 1);
      }
      array.push(item);
      return array;
    }
    timestampToDate(timestamp) {
      let options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      };
      let date = new Date(Number(timestamp)).toLocaleString('es-AR', options);
      return date;
    }
  
    traductor(mensaje){
      let mensajeFinal="";
      switch (mensaje){
  
          case 'signInWithEmailAndPassword failed: First argument "email" must be a valid string.':{
            mensajeFinal="Por favor rellene los campos de Email y contraseña";
            break;
          }
          case "The email address is badly formatted.":{
            mensajeFinal="Por favor ingrese un email Valido";
            break;
          }
          case 'signInWithEmailAndPassword failed: Second argument "password" must be a valid string.':{
            mensajeFinal="Por favor rellene los campos de Email y contraseña";
            break;          
          }
          case "The password is invalid or the user does not have a password.":{
            mensajeFinal="La contraseña es invalida o el usuario no tiene una.";
            break;          
          }
          case "There is no user record corresponding to this identifier. The user may have been deleted.":{
            mensajeFinal="Usuario o contraseña incorrectos.";
            break;          
          }
          case "A network error (such as timeout, interrupted connection or unreachable host) has occurred.":{
            mensajeFinal="Parece que no tienes internet o la conexion no es buena.";
            break;          
          }
  
          //REGISTER
  
          case "The email address is already in use by another account.":{
            mensajeFinal="El email ya esta en uso por otra cuenta";
            break;          
          }        
          case 'createUserWithEmailAndPassword failed: First argument "email" must be a valid string.':{
            mensajeFinal="Rellene todos los campos y luego presione en Registrarme";
            break;          
          }
          case 'createUserWithEmailAndPassword failed: Second argument "password" must be a valid string.':{
            mensajeFinal="Rellene todos los campos y luego presione en Registrarme";
            break;          
          }
          case 'The email address is badly formatted.':{
            mensajeFinal="El email debe contener @";
            break;          
          }  
          case 'The email address is badly formatted.':{
            mensajeFinal='El email debe contener "@" y terminar en ".com"';
            break;          
          }           
          case 'Password should be at least 6 characters':{
            mensajeFinal='La contraseña debe contener al menos 6 caracteres.';
            break;          
          }
          default:{
            mensajeFinal='No se ha podido iniciar la sesion.';
            break;  
          }                       
        }
      return mensajeFinal;
    }
}
